export default "__VITE_ASSET__55a99e9e__"